import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoldHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M2 12h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M22 12h-6" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 8v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 14v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 20v2" }),
		/* @__PURE__ */ _jsx("path", { d: "m19 9-3 3 3 3" }),
		/* @__PURE__ */ _jsx("path", { d: "m5 15 3-3-3-3" })
	]
});
const ForwardRef = forwardRef(SvgFoldHorizontal);
export default ForwardRef;
